import { FC } from 'react';
import { useFormContext } from 'react-hook-form';

import { InputClearIconShell } from '~src/commons/components/text-input/input-clear-icon-shell';
import { InputInfoIconShell } from '~src/commons/components/text-input/input-info-icon-shell';

import { AddressFormFields } from '../types';

interface InputElementExtensionProps {
  name: keyof AddressFormFields;
  hasValue: boolean;
  setFocused: React.Dispatch<React.SetStateAction<boolean>> | ((focus: boolean) => void);
  isFocused: boolean;
  onBlur?: () => void;
  tooltipText?: string;
  showClearButton?: boolean;
}

export const InputElementExtension: FC<InputElementExtensionProps> = ({
  isFocused,
  showClearButton,
  tooltipText,
  hasValue,
  name,
  onBlur,
  setFocused,
}) => {
  const { setValue, trigger } = useFormContext();

  const handleIconClick = () => {
    if (name) {
      setFocused(false);
      onBlur?.();
      setValue(name, '');
      trigger(name);
    }
  };

  const showTooltip = !isFocused && !!tooltipText;
  const showClearIcon = isFocused && showClearButton && hasValue;

  if (showTooltip) {
    return <InputInfoIconShell message={tooltipText} />;
  } else if (showClearIcon) {
    return (
      <InputClearIconShell color="darkGrey" width={16} height={13} onClick={handleIconClick} />
    );
  }

  return null;
};
